import React from "react";
import { observer } from "mobx-react";
import { Box, Typography, useTheme } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AcxButton from "components/UI/AcxButton";
import { useStore } from "utils/useStore";
import AgentStore from "../Stores/AgentStore";

/** What's left of the agreement after "Not now". */
export const KboUserAgreementCollapsedBanner = observer(() => {
    const agentStore = useStore(AgentStore);
    const theme = useTheme();

    return (
        <Box
            id="kbo-user-agreement-collapsed"
            sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1.5,
                paddingBlock: 1.5,
                paddingInline: 2,
                border: `1px solid ${theme.palette.primary[200]}`,
                borderRadius: `${theme.shape.borderRadius * 2}px`,
                backgroundColor: theme.palette.primary[50],
            }}
        >
            <LockOutlinedIcon
                sx={{ fontSize: "20px", color: theme.palette.primary.main }}
            />
            <Box sx={{ flex: 1, minWidth: "200px" }}>
                <Typography
                    sx={{
                        fontSize: "14px",
                        fontWeight: 600,
                        lineHeight: "20px",
                        color: theme.palette.gray[700],
                    }}
                >
                    KBo is ready once you accept the user agreement
                </Typography>
                <Typography
                    sx={{
                        fontSize: "13px",
                        lineHeight: "18px",
                        color: theme.palette.gray[600],
                    }}
                >
                    It takes a couple of minutes, and you'll only do it once.
                    Your reading progress is saved.
                </Typography>
            </Box>
            <AcxButton
                id="kbo-user-agreement-review"
                fullWidth={false}
                onClick={() => agentStore.showUserAgreement()}
            >
                Review agreement
            </AcxButton>
        </Box>
    );
});
